import { useQuery } from '../useQuery/useQuery'
import { useAuth } from '../useAuth/useAuth'

import { getPartnerRestrictedDonationConfig } from '@percent/workplace-giving/api/auth/getPartnerRestrictedDonationConfig/getPartnerRestrictedDonationConfig'

export const useRestrictedDonationConfig = () => {
  const { state } = useAuth()

  const { data, isLoading: isBlockedRegionsLoading } = useQuery(
    ['getPartnerRestrictedDonationConfig'],
    getPartnerRestrictedDonationConfig,
    {
      enabled: state.status === 'authorized',
      staleTime: 1000 * 60 * 5
    }
  )

  return {
    blockedRegions: data?.blockedRegions ?? [],
    allowlistedCountryCodes: data?.allowlistedCountryCodes ?? [],
    isBlockedRegionsLoading
  }
}
